import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import PrimaryButton from '../button/PrimaryButton';
import SecondaryButton from '../button/SecondaryButton';

interface DeleteConfirmationDialogProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	groupName: string;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
	open,
	onClose,
	onConfirm,
	groupName,
}) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="xs" id="delete-group-dialog">
			<DialogContent>
				<DialogContentText className="!mt-4 !font-inter !text-[000] !text-[14px] !text-center !text-primary-grey">
				<span style={{fontWeight:"600", paddingBottom:"10px", display:"inline-block"}}>CAREFUL: This will delete all sites within the group.</span> <br />
					Are you sure you want to remove <span style={{fontWeight:"600"}}>{groupName}</span> and all its sites?
				</DialogContentText>
			</DialogContent>
			<DialogActions
				style={{ justifyContent: 'center', marginBottom: '15px' }}
			>
				<PrimaryButton
					addStyle="!w-[62px] !h-[36px]"
					onClick={onConfirm}
				>
					Yes
				</PrimaryButton>
				<SecondaryButton
					onClick={onClose}
					addStyle="!w-[62px] !h-[36px]"
				>
					No
				</SecondaryButton>
			</DialogActions>
		</Dialog>
	);
};

export default DeleteConfirmationDialog;
